import React from 'react'
import SwitchRouter from 'components/SwitchRouter'
import { Route } from 'react-router-dom'
import CartaoRoutes from './cartao/Routes'
import Cupons from './cupons/Cupons'
import EmAberto from './em-aberto/EmAberto'
import { Detailing } from './em-aberto/Detailing'
import { ComplianceFiscal } from './compliance-fiscal/ComplianceFiscal'

export default function RecebiveisRoutes() {
    return (
        <SwitchRouter>
            <Route exact path='/recebiveis/cartao' component={CartaoRoutes} />
            <Route exact path='/recebiveis/cupons' component={Cupons} />
            <Route exact path='/recebiveis/compliance-fiscal' component={ComplianceFiscal} />
            <Route exact path='/recebiveis/em-aberto' component={EmAberto} />
            <Route exact path='/recebiveis/em-aberto/detalhamento' component={Detailing} />
        </SwitchRouter>
    )
}
